import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {CircularSpinner} from "@khanacademy/wonder-blocks-progress-spinner";

const CenteredCircularSpinner = (): React.ReactElement => (
    <View style={styles.spinnerContainer}>
        <CircularSpinner />
    </View>
);

const styles = StyleSheet.create({
    spinnerContainer: {
        flexGrow: 1,
        alignItems: "center",
        justifyContent: "center",
    },
});

export default CenteredCircularSpinner;
